import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";

export async function getSessionDetails() {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  const response = await fetch(`${BASE_URL}/api/user/get-session-details`, {
    method: "get",
    headers,
    credentials: "include",
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

export async function login({ email, pwd }) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/user/login`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({
      email,
      pwd,
    }),
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

export async function forgotPassword({ email }) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/user/forgot-password`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({
      email
    }),
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

export async function resetPassword({ password, token }) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/user/reset-password`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({
      password,
      token
    }),
  });

  const res = await response.json();
  return res;
}

export async function registerUser({ email, password }) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/user/register`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({
      email,
      password
    }),
  });

  const res = await response.json();
  return res;
}

export async function registerCompany({ name, email, contactName, contactNumber }) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/company/register`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify({
      name,
      email,
      contactName,
      contactNumber
    }),
  });

  const res = await response.json();
  return res;
}

export async function verifyCompany(values) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/company/verify`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify(values),
  });

  const res = await response.json();
  return res;
}

export async function verifyUser(values) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");

  const response = await fetch(`${BASE_URL}/api/user/verify-email`, {
    method: "post",
    headers,
    credentials: "include",
    body: JSON.stringify(values),
  });

  const res = await response.json();
  return res;
}
